import moment from "moment";
import { ActivityTypes, DealInsightTab, DealInsightTimelineMode } from "src/types/dealInsights";

// Bulk Filters initial values
export const BulkFiltersDefaultValues: Record<string, number | string | null | boolean | string[]> = {
    pipelineExternalId: null,
    stageExternalId: null,
    ownerExternalId: null,
    riskStatus: DealInsightTab.ALL,
    minAmount: null,
    maxAmount: null,
    closeDateFrom: null,
    closeDateTo: null,
    lastActivityFrom: null,
    lastActivityTo: null,
    createdDateFrom: null,
    createdDateTo: null,
    // hasDealRoom: true,
};

// insights labels
export const inSightsLabel = {
    totalActiveDeals: 'Total Active Deals',
    valueByRevenue: "Value By Revenue",
    thisMonthActivityChangePct: "This month's activity",
    avgDealSize: "Avg Deal Size",
    dealsAtRisk: "Deals at risk",
}

export const dealInsightsTabs: { label: string, value: string }[] = [
    {
        label: 'all deals',
        value: DealInsightTab.ALL
    },
    {
        label: 'on target',
        value: DealInsightTab.ON_TARGET
    },
    {
        label: 'slipping away',
        value: DealInsightTab.SLIPPING_AWAY
    },
    {
        label: 'at risk',
        value: DealInsightTab.AT_RISK
    },
];

export const dealInsightTimelineTabs: { label: string, value: string }[] = [
    {
        label: 'both',
        value: DealInsightTimelineMode.BOTH,
    },
    {
        label: 'activity',
        value: DealInsightTimelineMode.ACTIVITY,
    },
    {
        label: 'prediction',
        value: DealInsightTimelineMode.PREDICTION,
    },
]

export const dealTableHeaders = [
    { label: 'Deal Name', width: 4, value: 'deal_name', sort: true },
    { label: 'Deal Value', width: 2, value: 'amount', sort: true },
    { label: 'Prediction', width: 2, value: 'health_score', sort: true },
    { label: 'Owner', width: 2, value: 'owner', sort: false },
    { label: 'Last Activity', width: 2, value: 'external_updated_at', sort: true },
];

export const activityIconMap: Record<string, string> = { // activity icon map
    [ActivityTypes.EMAIL]: 'paperflite-mail',
    [ActivityTypes.CALL]: 'paperflite-call',
    [ActivityTypes.MEETING]: 'paperflite-calendar',
    [ActivityTypes.TASK]: 'paperflite-action-plan',
    [ActivityTypes.NOTE]: 'paperflite-notes',
    [ActivityTypes.STAGE_CHANGE]: 'paperflite-stage',
};


export const activityFilterOptions: Record<string, any>[] = [ // activity filter options
    { value: 'all', label: 'All activity' },
    { value: ActivityTypes.EMAIL, label: 'Email' },
    { value: ActivityTypes.CALL, label: 'Call' },
    { value: ActivityTypes.MEETING, label: 'Meeting' },
    { value: ActivityTypes.NOTE, label: 'Note' },
    { value: ActivityTypes.TASK, label: 'Task' },
];

export const activityGraphLabel = { // activity graph label
    [ActivityTypes.EMAIL]: 'Email',
    [ActivityTypes.CALL]: 'Call',
    [ActivityTypes.MEETING]: 'Meeting',
    [ActivityTypes.NOTE]: 'Note',
    [ActivityTypes.TASK]: 'Task',
    [ActivityTypes.STAGE_CHANGE]: 'Deal Stage',
}

export const hasDealRoomOptions = [
    {
        label: 'Yes',
        value: true
    },
    {
        label: 'No',
        value: false
    },
]

export const dateFilterFormatter = (value?: string | number | null) => {
    return moment(Number(value));
};

export const bulkFiltersMultiSelectKeys: string[] = ['stageExternalId', 'ownerExternalId'];

// export const nudgeActionIconMap: Record<string, string> = {
//     [ActivityTypes.CALL]: 'paperflite-call',
//     [ActivityTypes.EMAIL]: 'paperflite-mail',
//     [ActivityTypes.NOTE]: 'paperflite-notes',
//     [ActivityTypes.TASK]: 'paperflite-action-plan',
//     [ActivityTypes.MEETING]: 'paperflite-calendar',
//     [ActivityTypes.STAGE_CHANGE]: 'paperflite-stage',
//     [NudgeActionTypes.DEAL_ROOM]: 'paperflite-deal-room',
//     [NudgeActionTypes.SHARE]: 'paperflite-share',
// };